import { reactive, toRefs, ref, computed } from 'vue';
import { getCharLikeNum, doLikeAction } from '@api/api';
import useCharInfo from '@hooks/useCharInfo';
import { useI18n } from 'vue-i18n';

const LIKE_TYPE_MAP = {
  role: 'ROLE',
  article: 'ARTICLE',
  playData: 'PLAY_DATA'
};

export default function useLike(likeTypeP) {
  const id = ref('');
  const likeType = ref('');
  likeType.value = LIKE_TYPE_MAP[likeTypeP];
  const { gameId, loginAccount } = useCharInfo();
  const showLikeBtn = computed(() => gameId.value && loginAccount.value);
  const { t } = useI18n();
  const likeState = reactive({
    linkTotalNum: 0,
    isLike: false,
    isShowAnimate: false,
  });

  // 点赞
  const like = async () => {
    const res: any = await doLikeAction({
      gameId: gameId.value,
      id: id.value,
      loginAccount: loginAccount.value,
      action: 'LIKE',
      likeType: likeType.value,
    });
    if (res?.result && res?.data) {
      likeState.linkTotalNum = res.data.TOTAL || 0;
      likeState.isLike = true;
      likeState.isShowAnimate = true;
    } else {
      alert(t('likeFail'));
    }
  };

  // 取消点赞
  const cancelLike = async () => {
    const res: any = await doLikeAction({
      gameId: gameId.value,
      id: id.value,
      loginAccount: loginAccount.value,
      action: 'CANCEL_LIKE',
      likeType: likeType.value,
    });
    if (res?.result && res?.data) {
      likeState.linkTotalNum = res.data.TOTAL || 0;
      likeState.isLike = false;
      likeState.isShowAnimate = false;
    } else {
      alert(t('likeFail'));
    }
  };

  // 获取点赞数据
  const updateLikeData = async (initId: string) => {
    id.value = initId;
    likeState.isShowAnimate = false;
    const res: any = await getCharLikeNum({
      gameId: gameId.value,
      id: id.value,
      loginAccount: loginAccount.value,
      likeType: likeType.value,
    });
    if (res?.result && res?.data) {
      likeState.linkTotalNum = res.data.TOTAL || 0;
      likeState.isLike = Boolean(+res.data.IS_LIKE) || false;
    }
  };

  const updateLikeDataCustomer = (newId: string, linkTotalNum: number, isLike: boolean) => {
    id.value = newId;
    likeState.linkTotalNum = linkTotalNum;
    likeState.isLike = isLike;
    likeState.isShowAnimate = false;
  }

  return {
    showLikeBtn,
    updateLikeData,
    updateLikeDataCustomer,
    like,
    cancelLike,
    ...toRefs(likeState),
  };
}
